import { createBeefCoPage, createLibrary, withBeefCoProject } from '@beefco/sdk';
import {
  AutoMetricApi,
  AutoMetricElement,
  AutoMetricGoal,
  AutoMetricParam,
  AutoMetricParams,
  YaMetricsCounter,
  YaMetricsPublisher,
  withAutoMetric,
} from '@beef/auto-metric';
import { compose, withReduxStore } from '@beef/redux';
import { withDataConverter } from '@beef/react';

import {
  CrudeContext,
  CrudeLogic,
  CrudeMapper,
  enhancedConnect,
  extractBeefCoDSL,
  lowCodePageMetrics,
  withCrudeMappingRoot,
} from 'utils/lowCodeHelpers';

import * as customComponents from './components';
import { initializeStore } from './store';
import * as components from '../../LowCode/components';
import { convertActionPageLCP } from './adapters';
import { BaseIcon } from '../ui/BaseIcon';

const library = createLibrary(
  {
    CrudeContext,
    CrudeMapper,
    CrudeLogic,
    AutoMetricElement: enhancedConnect()(AutoMetricElement),
    AutoMetricGoal: enhancedConnect()(AutoMetricGoal),
    AutoMetricParam: enhancedConnect()(AutoMetricParam),
    AutoMetricParams: enhancedConnect()(AutoMetricParams),
    BaseIcon,
    ...components,
    ...customComponents,
  },
  module,
  { useTsPropParser: true },
);
const _ActionPageLCP = createBeefCoPage({
  library,
  pageSlug: 'PromoAction',
});

const yaMetricCounter = new YaMetricsCounter(26001372);
export const lowCodeMetricApi = new AutoMetricApi([new YaMetricsPublisher(yaMetricCounter)]);

const generateLPName = () => {
  const path = window.location.pathname.split('/').filter(Boolean).at(-1);
  return `actions_details/${path}`;
};

// https://beefco-stage.apps.yd-kt05.vimpelcom.ru/?url=http://localhost:8080/customers/products/promo-action/
export const ActionPageLCP = compose<React.FC<any>>(
  withBeefCoProject(undefined, extractBeefCoDSL),
  withDataConverter(convertActionPageLCP),
  withReduxStore(initializeStore),
  withCrudeMappingRoot({
    selectState: (state) => {
      return state.data;
    },
  }),
  withAutoMetric.Root(lowCodeMetricApi, () => ({
    ...lowCodePageMetrics(),
    name: generateLPName(),
  })),
)(_ActionPageLCP);
